import eventCategoryConfig from '../../../config/event_categories.json'

// config/event_categories.json is shared with the server (EventCategories in Ruby).
// The picker shows each subcategory as "name (examples)" and saves the name.
export const EventCategoriesTree: Record<string, string[]> = Object.fromEntries(
  eventCategoryConfig.categories.map(category => [
    category.name,
    category.subcategories.map(subcategory => `${subcategory.name} ${subcategory.examples}`),
  ]),
)

const EventCategories = Object.keys(EventCategoriesTree)
export default EventCategories

// The keys the server accepts for a category filter (Types::EventCategoryEnum:
// each category name parameterized, e.g. 'Food & Drink' -> 'food_drink').
export const EventCategoryKeys: string[] = EventCategories.map(category =>
  category
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, ''),
)
